import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";

// Campo di ricerca suggerita/autocomplete condiviso: filtra durante la digitazione,
// case-insensitive, senza premere Invio, con una X per cancellare rapidamente.
export function SearchBox({ value, onChange, placeholder, testid, className = "", autoFocus = false }) {
  return (
    <div className={`relative ${className}`}>
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400 pointer-events-none" />
      <Input
        data-testid={testid}
        value={value}
        autoFocus={autoFocus}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="pl-9 pr-9 h-11"
      />
      {value && (
        <button
          type="button"
          data-testid={testid ? `${testid}-clear` : "search-clear"}
          onClick={() => onChange("")}
          aria-label="Cancella ricerca"
          className="absolute right-2.5 top-1/2 -translate-y-1/2 h-6 w-6 rounded-full flex items-center justify-center text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
